(function($) {
  $(document).ready(function() {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('.back-top').fadeIn();
      } else {
        $('.back-top').fadeOut();
      }
    });

    // scroll body to 0px on click
    $('.back-top').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 1600);

      return false;
    });
    
    if (menu_sticky) {
      var header_height = $('.header').outerHeight();
      $(window).scroll(function () {
        var scrollTop 	= $(this).scrollTop();
        var w 			= window.innerWidth;
        if (scrollTop > header_height) {
          if (w > 767) {
            $('body').removeClass('menu-fixed').addClass('menu-fixed');
            $('.main-content').css('padding-top', header_height);
          }
        }
        else {
          $('body').removeClass('menu-fixed');
          $('.main-content').css('padding-top', 30);
        }
      })
    }
    
    $('.product-swatches li').hover(function() {
      var d = new Date();
      var n = d.getTime();
      var img = $(this).find('div.hidden a').attr('href');
      $(this).parents('.product-item').find('.img-second > img').attr('src', img + '?' + n);
      $(this).parents('.product-item').find('.img-second').css({'opacity':'1', 'visibility':'visible', 'z-index':'2'});
    });
    
    $(".product-item .product-image").hover(
      function (){
        $(this).find('.img-second').css({'opacity':'1', 'visibility':'visible', 'z-index':'2'});
      },
      function (){
        $(this).find('.img-second').css({'opacity':'0', 'visibility':'hidden', 'z-index':'-1'});
      }
    );
    
    if (window.use_color_swatch) {
      $('.swatch :radio').change(function() {
        var option_index = $(this).closest('.swatch').data('option-index');
        var option_value = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(option_index).val(option_value).trigger('change');
      });
    }
  });
  
  if ($(".col-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!noutheme.is_clicked) {
        noutheme.getParams();
        var new_url = noutheme.createUrl();
        noutheme.filterGetContent(new_url);
        noutheme.reSidebar();
      }
      noutheme.is_clicked = false;
    });
  }
                    
  $(document).ready(function() {
    noutheme.init();
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      if ($('.modal').is(':visible')) {
        $('.modal').fadeOut();
      }
      noutheme.closeQuickViewPopup();
    }
  });
  
  var noutheme = {
    is_clicked: false,
    timeout: null,    
    init: function() {
      this.initModal();
      this.initMiniCart();
      this.AddToCart();
      this.AddToCart_ProductPage();
      this.initProductImageGallery();
      this.elevateZoom();
      this.QuickView();
      this.extendOwlCarousel();
      this.initCollectionSidebar();
    },
    initMiniCart: function() {
      if (minicart_type == 'click') {
        $('#minicart-toogle').click(function() {
          if ($('.dropminicart-content').is(':visible')) {
            $(".dropminicart-content").slideUp('fast');
          }
          else {
            $(".dropminicart-content").slideDown('fast');
          }
        })
      }
      else {
        if (!('ontouchstart' in document)) {
          $('#minicart-toogle').hover(function() {
            if (!$('.dropminicart-content').is(':visible')) {
              $(".dropminicart-content").slideDown('fast');
            }
          });
          $('.header-minicart').mouseleave(function() {
            $(".dropminicart-content").slideUp('fast');
          });
        }
        else {
          $('#minicart-toogle').click(function() {
            if ($('.dropminicart-content').is(':visible')) {
              $(".dropminicart-content").slideUp('fast');
            }
            else {
              $(".dropminicart-content").slideDown('fast');
            }
          });
        }
      }
      
      noutheme.checkItemsInMiniCart();
      
      $('.header-minicart .btn-remove').click(function(e) {
        e.preventDefault();
        var product_id = $(this).parents('li.item').data('product_id');
        Shopify.removeItem(product_id, function(cart) {
          noutheme.AjaxUpdateMiniCart(cart);
        });
      });
    },
    AddToCart: function() {
      if ($('.addtocart').length > 0) {
        $(document).on('click', '.addtocart', function(e) {
          e.preventDefault();
          if ($(this).attr('disabled') != 'disabled') {
            var productId = $(this).data('product-id');
            
            if (!window.ajax_cart) {
              $('#product-actions-' + productId).submit();
            }
            else {
              var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
              }
              
              var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              
              var title = $(this).parents('.product-item').find('.product-title').html();
              var image = $(this).parents('.product-item').find('.product-image img').attr('src');
              
              noutheme.AjaxAddToCart(variant_id, quantity, title, image);
            }
          }
          
          return false;
        })
      }
    },
    AddToCart_ProductPage: function() {
      if ($('#AddToCart-product-template').length > 0) {
        $('#AddToCart-product-template').click(function(e) {
          e.preventDefault();
          if ($(this).attr('disabled') != 'disabled') {
          	if (!window.ajax_cart) {
              $(this).parents('form').submit();
            } else {
              var variant_id = $(this).parents('form').find('select[name=id]').val();
              if (!variant_id) {
                variant_id = $(this).parents('form').find('input[name=id]').val();
              }
              var quantity = $(this).parents('form').find('input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              var title = $('.product-title h2').text();
              var image = $('#product-featured-image').attr('src');
              noutheme.AjaxAddToCart(variant_id, quantity, title, image);
            }
          }
          
          return false;
        })
      }
    },
    AjaxAddToCart: function(variant_id, quantity, title, image) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        beforeSend: function() {
          $('.loading-modal').show();
        },
        success: function(msg) {
          $('.loading-modal').hide();
          $('.ajax-success-modal').find('.product-title').html(title);
          $('.ajax-success-modal').find('.product-image').attr('src', image);
          $('.ajax-success-modal').find('.btn-view-wishlist').hide();
          $('.ajax-success-modal').find('.btn-view-cart').show();

          noutheme.showModal('.ajax-success-modal');
          noutheme.updateMiniCart();
        },
        error: function(xhr, text) {
          $('.loading-modal').hide();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          noutheme.showModal('.ajax-error-modal');
        }
      });
    },
    updateMiniCart: function() {
      Shopify.getCart(function(cart) {
        noutheme.AjaxUpdateMiniCart(cart);
      });
    },
    AjaxUpdateMiniCart: function(cart) {
      var html = '';
      html	+= '<li class="item" data-product_id="{ID}">';
      	html	+= '<a href="{URL}" class="product-image">';
      		html	+= '<img src="{IMAGE}" alt="{TITLE}">';
      	html	+= '</a>';
      	html	+= '<div class="product-info">';
      		html	+= '<a href="javascript:void(0)" title="Remove This Item" class="btn-remove">x</a>';
      		html	+= '<div class="product-title">';
      			html	+= '<a href="{URL}">{TITLE}</a>';
      		html	+= '</div>';        
     	html	+= '</div>';
     	html	+= '<div class="product-price">';
     		html	+= '{QUANTITY} x <span class="price">{PRICE}</span>';
     	html	+= '</div>';
      html	+= '</li>';
      
      $('.header-minicart #minicart-count').text(cart.item_count);
      $('.header-minicart .price-total .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
      $('.header-minicart .minicart-products-list').html('');
      if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = html;
          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(/\{TITLE\}/g, cart.items[i].title);
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
          item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
          $('.header-minicart .minicart-products-list').append(item);
        }
        
        $('.header-minicart .btn-remove').click(function(e) {
          e.preventDefault();
          var product_id = $(this).parents('li.item').data('product_id');
          Shopify.removeItem(product_id, function(cart) {
            noutheme.AjaxUpdateMiniCart(cart);
          });
        });
        
        if (noutheme.convertCurrency()) {
          Currency.convertAll(window.shop_currency, $('.currency-picker').data('value'), '.dropminicart-content span.money', 'money_format');
        }
      }
      noutheme.checkItemsInMiniCart();
    },
    checkItemsInMiniCart: function() {
      if ($('.header-minicart .minicart-products-list').children().length > 0) {
        $('.header-minicart .no-items').hide();
        $('.header-minicart .has-items').show();
      } else {
        $('.header-minicart .has-items').hide();
        $('.header-minicart .no-items').show();
      }
    },
    AddWishlist: function() {
      $(document).on('click', 'button.wishlist', function(e) {
        e.preventDefault();
        var form = $(this).parent();
        var item = form.parents('.grid-item');
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: form.serialize(),
          beforeSend: function() {
            noutheme.AjaxLoading('show');
          },
          success: function(data) {
            noutheme.AjaxLoading('hide');
            form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
            var title = item.find('.product-title').html();
            var image = item.find('a > img').attr('src');
            $('.ajax-success-modal').find('.ajax-product-title').html(title);
            $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
            $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
            $('.ajax-success-modal').find('.btn-go-to-cart').hide();
            noutheme.showModal('.ajax-success-modal');
          },
          error: function(xhr, text) {
            noutheme.AjaxLoading('hide');
            $('.loading-modal').hide();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            noutheme.showModal('.ajax-error-modal');
          }
        });
      })
    },
    elevateZoom: function() {
      if (!$('.more-view-image .product-photo-thumbs a.elevatezoom-gallery').hasClass('actived')) {
        $('.more-view-image .product-photo-thumbs .owl-item:first-child a.elevatezoom-gallery').addClass('actived');
      }
      if (!$('.more-view-image-vertical .product-photo-thumbs a.elevatezoom-gallery').hasClass('actived')) {
        $('.more-view-image-vertical .product-photo-thumbs .owl-item:first-child a.elevatezoom-gallery').addClass('actived');
      }
      if ($('#product-featured-image').length > 0) {
        $("#product-featured-image").elevateZoom({
          loadingIcon: window.loading_url,
          gallery: 'more-view-slider',
          galleryActiveClass: 'actived',
          cursor: "crosshair",
          scrollZoom: true
        })
        
//         $("#product-featured-image").bind("click", function(e) {
//           var ez = $('#product-featured-image').data('elevateZoom');
//           $.fancybox(ez.getGalleryList());
//           return false;
//         });
      }
    },
    AjaxLoading: function(t) {
      if (t== 'show') {
        $('.ajax-loading').show();
      }
      else {
        $('.ajax-loading').hide();
      }
    },
    initModal: function() {
      $('.btn-continue-shopping').click(function() {
        $('.ajax-success-modal').fadeOut(500);
      });
      
      $('.close-modal, .overlay').click(function() {
        $('.ajax-success-modal').fadeOut(500);
      });
    },
    showModal: function(el) {
      $(el).fadeIn(500);
      $(el).css('opacity', 1);
//       noutheme.timeout = setTimeout(function() {
//         $(el).fadeOut(500);
//       }, 5000);
    },
    QuickView: function() {
      if ($('.quickview-button a').length > 0) {
        $(document).on('click', '.quickview-button a', function(e) {
          var product_handle = $(this).attr('id');
          Shopify.getProduct(product_handle, function(product) {
            var template = $('#nou__quickview-template').html();
            $('.quick-view').html(template);
            var quickview = $('.quick-view');
            
            quickview.find('.product-title').html(product.title);
            if (quickview.find('.product-vendor span').length > 0) {
              quickview.find('.product-vendor span').text(product.vendor);
            }
            if (quickview.find('.product-type span').length > 0) {
              quickview.find('.product-type span').text(product.type);
            }
            if (quickview.find('.product-inventory span').length > 0) {
              var variant = product.variants[0];
              var inventoryInfo = quickview.find('.product-inventory span');                      
              if (variant.available) {
                if (variant.inventory_management!=null) {
                  inventoryInfo.text(window.inventory_text.in_stock);
                } else {
                  inventoryInfo.text(window.inventory_text.many_in_stock);
                }
              } else {
                inventoryInfo.text(window.inventory_text.out_of_stock);
              }
            }
            if (quickview.find('.product-description').length > 0) {
              var description = product.description.replace(/(<([^>]+)>)/ig, "");
              var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
              description = description.split(" ").splice(0, 20).join(" ") + "...";
              quickview.find('.product-description').text(description);
            }
            quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find('.product-item').attr('id', 'product-' + product.id);
            quickview.find('.variants').attr('id', 'product-actions-' + product.id);
            quickview.find('.variants select').attr('id', 'product-select-' + product.id);

            if (product.compare_at_price > product.price) {
              quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
            } else {
              quickview.find('.compare-price').html('');
            }
            
            if (!product.available) {
              quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
              quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
            } else {
              quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
              if (window.use_color_swatch) {
                noutheme.QuickView_Variants_Swatches(product, quickview);
              } else {
                noutheme.QuickView_Variants(product, quickview);
              }
            }
            
            quickview.find(".button").on("click", function() {
              var oldValue = quickview.find(".quantity").val(),
                  newVal = 1;
              if ($(this).text() == "+") {
                newVal = parseInt(oldValue) + 1;
              } else if (oldValue > 1) {
                newVal = parseInt(oldValue) - 1;
              }
              quickview.find(".quantity").val(newVal);

              if (quickview.find(".total-price").length > 0) {
                noutheme.updatePriceQuickview();
              }
            });
            
            noutheme.QuickView_Slider(product, quickview);
            noutheme.AddToCart_QuickView();
            
            $('.quick-view').fadeIn(500);
            if ($('.quick-view .total-price').length > 0) {
              $('.quick-view input[name=quantity]').on('change', noutheme.updatePriceQuickview);
            }
          });
          
          return false;
        });
        
        $(document).on("click", ".quick-view .overlay, .close-window", function() {
          noutheme.closeQuickViewPopup();
          return false;
        });
      }
    },
    closeQuickViewPopup: function() {
      $('.quick-view').fadeOut();
    },
    QuickView_Variants_Swatches: function(product, quickview) {
      if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
          quickview.find('form.variants > select').append(option);
        }
        
        var file_url 	= window.file_url.substring(0, window.file_url.lastIndexOf('nou_?'));
        var asset_url 	= window.asset_url.substring(0, window.asset_url.lastIndexOf('nou_?'));
        var options 	= "";
        for (var i = 0; i < product.options.length; i++) {
          options += '<div class="swatch clearfix" data-option-index="' + i + '">';
          options += '<div class="header">' + product.options[i].name + '</div>';
          var is_color = false;
          if (/Color|Colour/i.test(product.options[i].name)) {
            is_color = true;
          }
          var optionValues = new Array();
          for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var value = variant.options[i];
            var valueHandle = this.convertToSlug(value);
            var Text = 'swatch-' + i + '-' + valueHandle;
            if (optionValues.indexOf(value) < 0) {
              options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';
              options += '<input id="' + Text + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';
              if (is_color) {
                options += '<label title="' + value + '" for="' + Text + '" style="background-color: ' + valueHandle + '; background-image: url(' + file_url + valueHandle + '.png)"><img class="crossed-out" src="' + asset_url + 'soldout.png" /></label>';
              } else {
                options += '<label title="' + value + '" for="' + Text + '">' + value + '<img class="crossed-out" src="' + asset_url + 'soldout.png" /></label>';
              }
              options += '</div>';
              if (variant.available) {
                $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
              }
              optionValues.push(value);
            }
          }
          options += '</div>';
        }
        
        quickview.find('form.variants > select').after(options);
        
        quickview.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').data('option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
      }
      else {
        quickview.find('form.variants > select').remove();
        quickview.find('form.variants').append('<input type="hidden" name="id" value="' + product.variants[0].id + '">');
      }
    },
    QuickView_Variants: function(product, quickview) {
      
    },
    convertToSlug: function(text) {
      var text = text.toLowerCase();
      text.replace(/[^a-z0-9 -]/g, '');
      text.replace(/\s+/g, '-');
      text.replace(/-+/g, '-');;
      return text;
    },
    updatePriceQuickview: function() {
      var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var price = $('.quick-view .price').text().match(regex);
      if (!price) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        price = $('.quick-view .price').text().match(regex);
      }
      
      if (price) {
        var unitPriceText = price[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt($('.quick-view input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;

        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
        if (!totalPriceText.match(regex)) {
          regex = /([0-9]+[.|,][0-9]+)/g;
        } 
        totalPriceText = totalPriceText.match(regex)[0];

        var regInput = new RegExp(unitPriceText, "g");
        var totalPrice = $('.quick-view .price').html().replace(regInput, totalPriceText);

        $('.quick-view .total-price span').html(totalPrice);
      }
    },
    AddToCart_QuickView: function() {
      if ($('.quick-view .addtocart').length > 0) {
        $(document).on('click', '.quick-view .addtocart', function() {
          var variant_id = $('.quick-view select[name=id]').val();
          if (!variant_id) {
            variant_id = $('.quick-view input[name=id]').val();
          }
          var quantity = $('.quick-view input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }

          var title = $('.quick-view .product-title a').html();
          var image = $('.quick-view .quickview-featured-image img').attr('src');
          noutheme.AjaxAddToCart(variant_id, quantity, title, image);
          noutheme.closeQuickViewPopup();
        });
      }
    },
    QuickView_Slider: function(product, quickview) {
      var featured_image = Shopify.resizeImage(product.featured_image, 'grande');
      quickview.find('.quickview-featured-image').append('<a href="' + product.url + '"><img src="' + featured_image + '" title="' + product.title + '"/></a>');
      if (product.images.length > 1) {
        var $owlcarousel = quickview.find('.more-view-image ul');
        var count = 0;
        for (i in product.images) {
          if (count < product.images.length) {
            var grande_image = Shopify.resizeImage(product.images[i], 'grande');
            var compact_image = Shopify.resizeImage(product.images[i], 'compact');
            var item = '<li><a href="javascript:void(0)" data-image="' + grande_image + '"><img src="' + compact_image + '"  /></a></li>';
            $owlcarousel.append(item);
            
            count = count + 1;
          }
        }
        $owlcarousel.find('a').click(function() {
          var featured_image = quickview.find('.quickview-featured-image img');
          if ($(this).data('image') != featured_image.attr('src')) {
            featured_image.attr('src', $(this).data('image'));
          }
        });
        
        noutheme.QuickView_OwlCarousel($owlcarousel);
      }
    },
    QuickView_OwlCarousel: function(qvowlcarousel) {
      if (qvowlcarousel) {
        qvowlcarousel.owlCarousel({
          items: 4,
          nav: true,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
          margin: 5,
          responsive: {
            0:{
              items: 1
            },
            481:{
              items: 2
            },
            768:{
              items: 3
            },
            992:{
              items: 4
            },
            1200:{
              items: 4
            }
          }
        }).css('visibility', 'visible');
      }
    },
    extendOwlCarousel: function() {
      $('.owl-carousel-wrap .owl-carousel').each(function() {
        var $carousel = $(this);
        if (!$carousel.hasClass('product-photo-thumbs')) {
          $carousel.owlCarousel({
            items : $carousel.data("items"),
            margin : $carousel.data("margin"),
            slideBy : $carousel.data("slideBy"),
            autoplay : $carousel.data("autoplay"),
            autoplayTimeout : $carousel.data("autoplayTimeout"),
            autoplayHoverPause : $carousel.data("autoplayHoverPause"),
            autoplaySpeed : $carousel.data("autoplaySpeed"),
            mouseDrag : $carousel.data("mouseDrag"),
            touchDrag : $carousel.data("touchDrag"),
            dots : $carousel.data("dots"),
            dotsSpeed : $carousel.data("dotsSpeed"),
            loop : $carousel.data("loop"),
            nav : $carousel.data("nav"),
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            navSpeed : $carousel.data("navSpeed"),
            center : $carousel.data("center"),
            lazyLoad : $carousel.data("lazyLoad"),
            responsive:{
              0:{
                items: $carousel.data("column_0"),
                nav: true
              },
              481:{
                items: $carousel.data("column_481"),
                nav: true
              },
              768:{
                items: $carousel.data("column_768")
              },
              992:{
                items: $carousel.data("column_992")
              },
              1200:{
                items: $carousel.data("column_1200")
              }
            }
          })
        }
      })
    },
    initCollectionSidebar: function() {
      if ($('.col-sidebar').length > 0) {
        noutheme.getParams();
        noutheme.getSortby();
        noutheme.filterEvents();
        noutheme.getPaging();
        noutheme.filterClear();
        noutheme.filterClearAll();
      }
    },
    getParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var key, i = 0, url = location.search.substr(1).split('&'); i < url.length; i++) {
          key = url[i].split('=');
          if (key.length > 1) {
            Shopify.queryParams[decodeURIComponent(key[0])] = decodeURIComponent(key[1]);
          }
        }
      }
    },
    getSortby: function() {
      if (Shopify.queryParams.sort_by) {
        var sort_by = Shopify.queryParams.sort_by;
        var sortby_text = $(".filter-sortby a[href='" + sort_by + "']").text();
        $(".filter-sortby > button span").text(sortby_text);
        $(".filter-sortby li.active").removeClass("active");
        $(".filter-sortby a[href='" + sort_by + "']").parent().addClass("active");
      }
    },
    filterEvents: function() {
      noutheme.filterCategories();
      noutheme.filterTags();
      noutheme.filterMode();
      noutheme.filterSortby();
    },
    filterCategories: function() {
      $(".col-sidebar .block-categories a").click(function(e) {
        if (!$(this).hasClass('active')) {
          delete Shopify.queryParams.q;
          noutheme.filterAjax($(this).attr('href'));

          $(".col-sidebar .block-categories a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },
    filterTags: function() {
      $(document).on('click', '.block-sidebar .filter-tag a:not(".clear"), .filter-tag label', function(e) {
        var current_tags = [];
        if (Shopify.queryParams.constraint) {
          current_tags = Shopify.queryParams.constraint.split('+');
        }
        
        if (!$(this).prev().is(":checked")) {
          var other_tag = $(this).parents('.filter-tag').find("input:checked");
          if (other_tag.length > 0) {
            var tag_name = other_tag.val();
            if (tag_name) {
              var tag = current_tags.indexOf(tag_name);
              if (tag >= 0) {
                current_tags.splice(tag, 1);
              }
            }
          }
        }

        var tag_name = $(this).prev().val();
        if (tag_name) {
          var tag = current_tags.indexOf(tag_name);
          if (tag >= 0) {
            current_tags.splice(tag, 1);
          } else {
            current_tags.push(tag_name);
          }
        }

        if (current_tags.length) {
          Shopify.queryParams.constraint = current_tags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }

        noutheme.filterAjax();
        e.preventDefault();
      })
    },
    filterMode: function() {
      $(".modes a").click(function(e) {
        if (!$(this).hasClass("active")) {
          if ($(this).hasClass("mode-list")) {
            Shopify.queryParams.view = "list";
          } else {
            Shopify.queryParams.view = '';
          }

          noutheme.filterAjax();
          $(".modes a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },
    filterSortby: function() {
      $('#sortby').change(function(e) {
        Shopify.queryParams.sort_by = $(this).val();
        noutheme.filterAjax();
        e.preventDefault();
      })
    },
    filterAjax: function(urlLink) {
      delete Shopify.queryParams.page;
      var new_url = noutheme.createUrl(urlLink);
      noutheme.is_clicked = true;
      History.pushState({param: Shopify.queryParams}, new_url, new_url);
      noutheme.filterGetContent(new_url);
    },
    createUrl: function(urlLink) {
      var params = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (urlLink) {
        if (params != "")
          return urlLink + "?" + params;
        else
          return urlLink;
      }
      
      return location.pathname + "?" + params;
    },
    filterGetContent: function(new_url) {
      $.ajax({
        type: 'get',
        url: new_url,
        beforeSend: function() {
          noutheme.AjaxLoading('show');
        },
        success: function(data) {
          noutheme.getData(data);
          noutheme.getPaging();
          noutheme.filterTags();
          noutheme.filterClear();
          noutheme.filterClearAll();
          noutheme.QuickView();
          noutheme.AddToCart();
          noutheme.AddWishlist();
          noutheme.AjaxLoading('hide');
        },
        error: function(xhr, text) {
          noutheme.AjaxLoading('hide');
          $('.loading-modal').hide();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          noutheme.showModal('.ajax-error-modal');
        }
      });
    },
    getData: function(data) {
      var current_html = $(".col-main .products-grid");
      if (current_html.length == 0) {
        current_html = $(".col-main .product-list");
      }
      
      var product_list = $(data).find(".col-main .products-grid");
      if (product_list.length == 0) {
        product_list = $(data).find(".col-main .product-list");
      }
      
      current_html.replaceWith(product_list);
      
      if (noutheme.convertCurrency()) {
        Currency.convertAll(window.shop_currency, $('.currency-picker').data('value'), '.col-main span.money', 'money_format');
      }
      
      if ($(".paging").length > 0) {
        $(".paging").replaceWith($(data).find(".paging"));
      } else {
        $(".col-main").append($(data).find(".paging"));
      }
      
      var header_current 	= $(".collection-header");
      var header_data 		= $(data).find(".collection-header");
      if (header_current.find("h2").text() != header_data.find("h2").text()) {
        header_current.find("h2").replaceWith(header_data.find("h2"));

        var des_current = $(".collection-description");
        var des_data 	= $(data).find(".collection-description");

        if (des_current.find(".rte").length) {
          if (des_data.find(".rte").length) {
            des_current.html(des_data.find(".rte"));
          } else {
            des_current.find(".rte").hide();
          }
        } else {
          des_current.html(des_data.find(".rte"));
        }

        var img_current = $(".collection-img");
        var img_data 	= $(data).find(".collection-img");
        if (img_current.find("p").length) {
          if (img_data.find("p").length) {
            img_current.html(img_data.find("p"));
          } else {
            img_current.find("p").hide();
          }
        } else {
          img_current.html(img_data.find("p"));
        }
      }
      
      $(".block-sidebar").replaceWith($(data).find(".block-sidebar"));
    },
    getPaging: function() {
      $(document).on('click', '.paging a', function(e) {
        var page = $(this).attr("href").match(/page=\d+/g);
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var new_url = noutheme.createUrl();
            noutheme.is_clicked = true;
            History.pushState({param: Shopify.queryParams}, new_url, new_url);
            noutheme.filterGetContent(new_url);
            
            $('body,html').animate({
              scrollTop: 500
            }, 600);
          }
        }
        e.preventDefault();
      })
    },
    reSidebar: function() {
      $(".col-sidebar .block-categories .active, .filter-tag .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);
      
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".col-sidebar .block-categories a[href='" + cat[0] + "']").addClass("active");
      }
      
      if (Shopify.queryParams.view) {
        $(".modes .active").removeClass("active");
        var view = Shopify.queryParams.view;
        if (view.indexOf("list") >= 0) {
          $(".modes .list").addClass("active");
          view = view.replace("list", "");
        } else {
          $(".modes .grid").addClass("active");
        }
      }
      
      noutheme.getSortby();
    },
    initProductImageGallery: function() {
      if ($('.product-single .more-view-image').length > 0) {
        noutheme.initOwlGallery();
      }else {
        if ($('.product-single .more-view-image-vertical').length) {
          noutheme.initJCarouselGallery();
        }
      }
    },
    initOwlGallery: function() {
      $('.more-view-image #more-view-slider').owlCarousel({
        items: 4,
        margin: 5,
        dots: false,
        nav: true,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        responsive: {
          0:{items: 1},
          481:{items: 2},
          768:{items: 3},
          992:{items: 4},
          1200:{items: 4}
        }
      });
    },
    initJCarouselGallery: function() {
      $('.more-view-image-vertical ul').jcarousel({
        vertical: true        
      }).css('visibility', 'visible');
      
      $('.product-img-box').addClass('has-jcarousel');
      $('.more-view-wrapper').css('visibility', 'visible');
    },
    filterClear: function() {
      
    },
    filterClearAll: function() {
      
    },
    convertCurrency: function() {
      return window.show_multiple_currency && Currency.currentCurrency != shopCurrency;
    }
  }
})(jQuery)